import { BaseFrameworkError } from "@bloglovin/vue-framework";

class ThemeError extends BaseFrameworkError {}

export default ThemeError;
